import { useMemo, useState } from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { Add, HelpOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import LogoutContainer from "../../Layout/LogoutContainer";
import { PageTitleSubtitle, StyledHeader } from "../../Common/styles/header";
import InstrumentsList from "./InstrumentsList";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { openHelp } from "../../../Redux/reducers/helpSlice";
import { platformAdminPermissions } from "../../../utils/roles";

const Instruments = () => {
  const { t: sidebarT } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions],
  );

  return (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <StyledHeader>
        <PageTitleSubtitle
          title="Artifacts"
          subtitle="Manage and monitor artifacts."
        />

        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          {canEdit && (
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New Artifact
            </Button>
          )}
          <Tooltip title={sidebarT("HELP_TOOLTIP")}>
            <IconButton onClick={() => dispatch(openHelp("artifacts-instruments"))} size="small">
              <HelpOutline />
            </IconButton>
          </Tooltip>
        </Box>
      </StyledHeader>
      <Box sx={{ p: 5, height: "calc(100% - 154px)", overflow: "auto" }}>
        <InstrumentsList showModal={showModal} setShowModal={setShowModal} />
      </Box>
    </>
  );
};

export default Instruments;
